import withInstall from '../utils/withInstall';
import _ConfigProvider from './config-provider';

export const ConfigProvider = withInstall(_ConfigProvider);
export default ConfigProvider;
